var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.meta && _vm.meta.method && _vm.meta.method === 'customUrl')?_c('div',[_c('meta',{attrs:{"http-equiv":"refresh","content":'0; url=' + _vm.layout[0]}})]):(_vm.layout)?_c('div',_vm._l((_vm.layout),function(part,index){return _c('div',{key:index,domProps:{"innerHTML":_vm._s(part)}})}),0):_vm._e(),_c('cookieBanner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }